import axios from 'axios'
import { ConfigRequisicaoUtils, SearchUrlParamBuilder } from '@/core/utils'
import { chavesConfigRequisicao } from '@/core/constants'
import atualizarAtaInput from '@/core/apiclient/ata/models/AtualizarAtaInput'
import inserirComProcessoInput from '@/core/apiclient/ata/models/InserirComProcessoInput'
import SalvarNumeroAtaInput from '@/core/apiclient/ata/models/SalvarNumeroAtaInput'

class AtaApiClient {
	URL_PATH = 'api/atas'

	async buscarPorId(idAta) {
		return await axios.get(`${this.URL_PATH}/${idAta}`)
	}

	async buscarAtasPorFiltro(filtro, paginacao) {
		const url = new SearchUrlParamBuilder({
			urlPath: this.URL_PATH,
			filters: filtro,
			pagingAndSorting: paginacao,
		}).buildFiltroPadraoEAvancado()
		return await axios.get(url)
	}

	async buscarAtasCollapses(filtro, paginacao) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${this.URL_PATH}/possuemAdesoes`,
			filters: filtro,
			pagingAndSorting: paginacao,
		}).buildFiltroPadraoEAvancado()
		return await axios.get(url)
	}

	async inserirAtaComProcesso({ idProcesso, inicioValidade, idOrgao }) {
		return await axios.post(
			`${this.URL_PATH}/comProcesso`,
			new inserirComProcessoInput(idProcesso, inicioValidade, idOrgao),
			ConfigRequisicaoUtils.montar(chavesConfigRequisicao.REDIRECIONAMENTO_DESABILITADO),
		)
	}

	async atualizarAtaComProcesso(ata) {
		return await axios.put(`${this.URL_PATH}/${ata.id}`, new atualizarAtaInput(ata))
	}

	async bloquearAta(idAta, justificativa) {
		return await axios.put(`${this.URL_PATH}/bloqueio/bloquear`, { idAta: idAta, justificativa: justificativa })
	}

	async desbloquear(idAta, justificativa) {
		return await axios.put(`${this.URL_PATH}/bloqueio/desbloquear`, { idAta: idAta, justificativa: justificativa })
	}

	async cancelarAta(idAta, motivo) {
		return await axios.put(`${this.URL_PATH}/${idAta}/cancelar`, { motivo })
	}

	async deletarPorId(idAta) {
		return await axios.delete(`${this.URL_PATH}/${idAta}`)
	}

	async salvarNumeroAta(idAta, numero) {
		return await axios.put(`${this.URL_PATH}/${idAta}/numeroAta`, new SalvarNumeroAtaInput(idAta, numero))
	}

	async efetivarAta(idAta) {
		return await axios.put(`${this.URL_PATH}/${idAta}/efetivar`)
	}

	async baixarModeloImportarPrevConsumo(idAta) {
		return await axios.get(`${this.URL_PATH}/${idAta}/baixar-modelo-importacao`, {
			responseType: 'arraybuffer',
		})
	}

	async verificarPlanilhaImportadaParaOrgao(idAta, idPlanilhaImportacao) {
		return await axios.get(
			`${this.URL_PATH}/${idAta}/verificar-planilha-importada?idPlanilhaImportacao=${idPlanilhaImportacao}`,
		)
	}

	async gerarModeloImportarPrevConsumo(idAta) {
		return await axios.post(`${this.URL_PATH}/${idAta}/gerar-modelo-importacao`)
	}

	async importarConsumo({ idAta, idArquivoTemporario }) {
		return await axios.post(`${this.URL_PATH}/${idAta}/importar-previsao`, { idArquivoTemporario })
	}

	async enviarAtaParaPncp(idAta) {
		return await axios.post(`${this.URL_PATH}/${idAta}/contratacao-publica/enviar`)
	}

	async excluirAtaNoPncp(idAta) {
		return await axios.delete(`${this.URL_PATH}/${idAta}/contratacao-publica/excluir`)
	}

	async reenviarAtaParaDetalhamento(idAta) {
		return await axios.post(`${this.URL_PATH}/${idAta}/detalhamento/enviar`)
	}

	async prorrogarAta(idAta, novaData) {
		return await axios.put(`${this.URL_PATH}/${idAta}/prorrogar`, novaData)
	}

	async buscarDataProrrogacao(idAta) {
		return await axios.get(`${this.URL_PATH}/${idAta}/prorrogar/data`)
	}

	async buscarContratados(idAta) {
		return await axios.get(`${this.URL_PATH}/${idAta}/contratados`)
	}

	async buscarAtividadesFiltro() {
		return await axios.get(`${this.URL_PATH}/atividades`)
	}

	async buscarOrgaosAtaFiltro(filtro) {
		let URL = new SearchUrlParamBuilder({
			urlPath: `${this.URL_PATH}/porFiltro/buscarOrgaos`,
			filters: filtro,
		}).build()

		return await axios.get(URL)
	}

	async buscarOrgaosParticipantesDaAta(idAta) {
		return await axios.get(`${this.URL_PATH}/${idAta}/buscarOrgaosParticipantes`)
	}
}

export default new AtaApiClient()
